import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModesoLocalizationModule } from '../../../modeso-lib-localization-fe/src/lib/localization.module';
import { CategoryFilterComponent } from './components/category-filter/category-filter.component';
import { DigitalProductListComponent } from './components/digital-product-list/digital-product-list.component';
import { DigitalProductTileComponent } from './components/digital-product-tile/digital-product-tile.component';
import { ProductsEffects } from './effects/products.effects';
import { ProductsConfig, ProductsConfigService } from './products.config';
import * as fromProducts from './reducers/products.reducer';
import { ProductsService } from './services/products.service';
@NgModule({
    declarations: [DigitalProductTileComponent, DigitalProductListComponent, CategoryFilterComponent],
    providers: [ProductsService],
    exports: [DigitalProductTileComponent, DigitalProductListComponent, CategoryFilterComponent],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromProducts.productsFeatureKey, fromProducts.reducer),
        EffectsModule.forFeature([ProductsEffects]),
        ModesoLocalizationModule,
    ],
})
export class ProductsModule {
    static forRoot(config: ProductsConfig): ModuleWithProviders<ProductsModule> {
        return {
            ngModule: ProductsModule,
            providers: [ProductsService, { provide: ProductsConfigService, useValue: config }],
        };
    }
}
